<template>
  <div id="app">
    <k-navbar></k-navbar>
    <router-view/>
    <k-footer></k-footer>
  </div>
</template>

<script>
import navbarView from '@/components/navbar.vue';
import footerView from '@/components/footer.vue';
export default {
  name: 'App',
  components: {
    'k-navbar': navbarView,
    'k-footer': footerView
  }
};
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/App.vue